
const getters = {
  userInfo: state => state.user.userInfo,
  token: state => state.user.token,
}
export default getters
